<template>
    <v-layout>
        <v-flex pb-4 pt-4>
            <h3>Вы можете бесплатно восстановить {{freeRecoveries}} КБМ.</h3>
            <h4 v-if="!freeRecoveries">Оформите три полиса и получите бесплатное восстановление! Уже оформлено {{policiesSold}} / 3.</h4>
        </v-flex>
    </v-layout>
</template>

<script>
export default {
    name: 'FreeRecoveriesInfo',
    props: {
        freeRecoveries: {
            default: 0
        },
        policiesSold: {
            default: 0
        }
    }
}
</script>

<style scoped>

/deep/ h1 {
    font-size: 65px;
    font-family: 'SFPro';
    line-height: 1.1;
    font-weight: 700;
    color: #000000;
}

@media(max-width: 600px){
    /deep/ h1 {
        font-size: 40px;
    }
}

@media(max-width: 480px) {
    /deep/ h1 {
        font-size: 30px;
    }
}

/deep/ h2, h3, h4 {
    font-family: 'SFProBold';
}

/deep/ h2 {
    font-size: 28px;
}

/deep/ h3 {
    font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/kbm/FreeRecoveriesInfo.vue